import { render, staticRenderFns } from "./EditDestinationModal.vue?vue&type=template&id=f23c460e&lang=pug&"
import script from "./EditDestinationModal.vue?vue&type=script&lang=js&"
export * from "./EditDestinationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports